import { CellContext } from '@tanstack/react-table';
import { getEnumValueConfig } from '@/components/table/_fieldDefinitions/enum/enumRegistry.ts';
import { EnumValueCell } from '@/components/table/_fieldDefinitions/_base/EnumValueCell.tsx';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

export const enumFieldRender = <T,>(
  info: CellContext<T, unknown>,
  customFieldsContext?: { enumSimpleName: string },
) => {
  const enumKey = info.getValue() as string;
  if (!enumKey) return <EmptyValue />;
  if (!customFieldsContext) return enumKey;

  const valueConfig = getEnumValueConfig(
    customFieldsContext.enumSimpleName,
    enumKey,
  );
  if (!valueConfig) return enumKey;

  return <EnumValueCell config={valueConfig} />;
};
